<!-- Header -->
<div class="md:px-4 p-3 flex align-items-center justify-content-between border-bottom-1 border-300 -mx-3 -mt-3">
  <h2 class="mb-0 text-sm"> {{ 'ADMIN.DOCUMENT.ADD_ATTACHMENT' | translate }}</h2>

  <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="close()"></div>
</div>
<!-- Header -->
<form class="-mx-3 -mb-3" #form="ngForm" *ngIf="folderForm" [formGroup]="folderForm" (ngSubmit)="saveFolderForm()">
  <!-- Modal Content -->
  <div class="surface-50 p-3 md:p-4">
    <div class="mb-5">
      <label class="font-medium text-700 text-xs mb-2 block uppercase"> {{ 'ADMIN.DOCUMENT.DOCUMENT_TYPE' |
        translate }}<sup class="p-error">*</sup></label>
      <p-select [options]="documentTypes" formControlName="document_type_id" optionLabel="name_primary_language"
        filterBy="name_primary_language" styleClass="w-full text-sm"
        placeholder=" {{ 'ADMIN.COMMON.SELECT' | translate }}">
        <ng-template pTemplate="selectedItem">
          <div class="text-sm">
            {{ DocumentTypeID?.value?.name_primary_language }}
          </div>
        </ng-template>
        <ng-template let-documentType pTemplate="item">

          <div class="text-sm">{{ documentType.name_primary_language }}</div>

        </ng-template>
        <ng-template pTemplate="footer">
          <div (click)="addFolder()" class="text-sm text-primary px-3 py-2 border-top-1 border-300">
            <i class="fa fa-plus mr-2"></i>{{ 'ADMIN.DOCUMENT.ADD_NEW_DOC_TYPE' | translate }}
          </div>
        </ng-template>
      </p-select>
      <app-error-msg *ngIf="DocumentTypeID?.touched && DocumentTypeID?.invalid" [errors]="DocumentTypeID?.errors"
        [fieldLabel]="'ADMIN.DOCUMENT.DOCUMENT_TYPE' | translate"></app-error-msg>
    </div>

    <div class="mb-2">
      <label class="font-medium text-700 text-xs mb-2 block uppercase">{{ 'ADMIN.DOCUMENT.ATTACH_DOC' | translate}}</label>

      <div
        class="border-1 border-round border-500 border-dashed surface-0 h-7rem w-full flex align-items-center mt-3 text-center h-11rem p-3 relative">
        <figure class="m-0 inline-block relative" *ngIf="DocumentFile.value; else notUploaded">
          <div
            class="surface-0 border-circle h-1rem w-1rem text-primary flex align-items-center justify-content-center cursor-pointer absolute right-0 top-0 mr-2 mt-2">
            <i class="fa fa-times text-xl text-xs" (click)="removeDocument()"></i>
          </div>
          <img *ngIf="file && file.type.includes('image')" width="197" height="148" [src]="DocumentFile.value"
            alt="abcd.jpg" />


          <figcaption *ngIf="file.type.includes('image')"
            class="absolute left-0 bottom-0 mb-1 p-2 text-white bg-black-alpha-40 w-full white-space-nowrap text-overflow-ellipsis overflow-hidden">
            {{file.name}}
          </figcaption>
          <span> {{file.name}} </span>
        </figure>

        <ng-template #notUploaded>
          <div class="mx-auto">
            
            <ngx-file-drop class=" absolute w-full h-full top-0 left-0  cursor-pointer" dropZoneLabel="Drop files here"
              (onFileDrop)="handleFileSelect($event)">
              <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                <div (click)="openFileSelector()" class="w-full h-full absolute left-0 top-0 pt-5">
                  <i class="fa fa-upload text-600 text-4xl"></i>
                  <p class="text-sm font-bold line-height-4 my-2 text-primary">

                    {{ 'ADMIN.DOCUMENT.DRAG_DROP' | translate }}
                    <span class="block text-primary">{{ 'ADMIN.DOCUMENT.BROWSE_FILE' | translate }}</span>
                  </p>
                  <p class="text-xs mb-0 text-500">
                    {{ 'ADMIN.DOCUMENT.ACCEPTED_FILE_TYPE' | translate }} .Jpeg, .PNG, .JPG, .Gif
                  </p>
                  <p class="text-xs mb-0 p-error">
                    {{ 'ADMIN.DOCUMENT.FILE_SIZE' | translate }}

                  </p>
                </div>
              </ng-template>
            </ngx-file-drop>

            
          </div>
        </ng-template>
      </div>
    </div>
    <app-error-msg *ngIf="DocumentFile?.touched && DocumentFile?.invalid" [errors]="DocumentFile?.errors"
              [fieldLabel]="'ADMIN.DOCUMENT.ATTACH_DOC' | translate"></app-error-msg>
  </div>
  <!-- Modal Content -->

  <!-- Modal Footer -->
  <div class="lg:px-4 px-2 py-3 border-top-1 border-300 surface-0">
    <div class="flex align-items-center justify-content-between">
      <div class="w-6">
        <p-button label="{{ 'ADMIN.COMMON.CANCEL' | translate }}" styleClass="p-button-link text-sm" (click)="close()">
        </p-button>
      </div>
      <div class="w-6 text-right">
        <button [loading]="isSubmitting" type="submit" pButton pRipple label="{{ 'ADMIN.DOCUMENT.UPLOAD' | translate }}"
          class="text-sm"></button>
      </div>
    </div>
  </div>
  <!-- Modal Footer -->
</form>